export default __webpack_public_path__ + "static/media/thop-pic.f69777a2.png";